import {Component, Injector} from '@angular/core';
import {fromUnixTime, isBefore} from 'date-fns';
import {ApiResponse} from '../../../../../Services/Api/base-api.service';
import {WidgetDataControllerComponent} from '../../../../Controller/widget-data-controller-component';
import {OrdersApiService} from '../../../../../Services/Api/Purchases/Orders/orders-api.service';
import {OrderDto} from '../../../../../Models/Purchases/Orders/order.interface';

@Component({
  selector: 'app-not-received-orders-widget',
  templateUrl: './not-received-orders-widget.component.html',
  styleUrls: ['./not-received-orders-widget.component.scss'],
  standalone: false
})
export class NotReceivedOrdersWidgetComponent extends WidgetDataControllerComponent<number> {

  override fakeData: number = 16;

  get widgetData(): number {
    return this.data || this.data === 0 ? this.data : this.fakeData;
  }

  constructor(
    protected override injector: Injector,
    protected ordersService: OrdersApiService,
  ) {
    super(injector, ordersService);
  }


  /**
   * Obtener los pedidos sin recibir
   *
   */
  override setData(data: OrderDto[]) {
    const now: Date = new Date();
    const localFilter: number = this.widgetsManager.filters?.local.id || 0;

    if (localFilter) {
      data = data.filter((item) => item.id_local === localFilter);
    }

    const dataAux: OrderDto[] = data.filter((item) => isBefore(fromUnixTime(Number.parseFloat(item.fecha_recepcion) / 1000), now)) || [];
    this.data = dataAux.length;
  }


  /**
   * Obtener datos
   *
   */
  getData(): Promise<ApiResponse> {
    return this.ordersService.getOrders();
  }

}
